import { createContext } from 'react';

export const InvoiceActionsContext = createContext<any>({
  setInvoiceActionsReferenceElement: null,
  invoiceActionsReferenceElement: null,
});
